// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.oc-profile-dropdown .dropdown-toggle {
  cursor: pointer;
}
.oc-profile-dropdown .dropdown-toggle::after {
  display: none;
}
.oc-profile-dropdown .dropdown-toggle img {
  width: 3.75rem;
  border: 3px solid var(--oc-primary-color);
}
.oc-profile-dropdown .dropdown-menu {
  border-radius: 0;
  border-top-right-radius: 2.25rem;
  padding-top: 0;
  padding-bottom: 0.875rem;
  overflow: hidden;
  background-color: var(--oc-primary-bg);
}
.oc-profile-dropdown .dropdown-header {
  font-family: "DMSans-Bold";
  font-size: 1rem;
  color: #fff;
  background-color: var(--oc-primary-color);
  margin-bottom: 0.625rem;
}
.oc-profile-dropdown .dropdown-item {
  color: #fff;
}
.oc-profile-dropdown .dropdown-item.active {
  font-family: "DMSans-Bold";
  background-color: transparent;
}
`, "",{"version":3,"sources":["webpack://./src/components/profileDropdown/ProfileDropdown.css"],"names":[],"mappings":"AAAA;EACE,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;EACd,yCAAyC;AAC3C;AACA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,cAAc;EACd,wBAAwB;EACxB,gBAAgB;EAChB,sCAAsC;AACxC;AACA;EACE,0BAA0B;EAC1B,eAAe;EACf,WAAW;EACX,yCAAyC;EACzC,uBAAuB;AACzB;AACA;EACE,WAAW;AACb;AACA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B","sourcesContent":[".oc-profile-dropdown .dropdown-toggle {\n  cursor: pointer;\n}\n.oc-profile-dropdown .dropdown-toggle::after {\n  display: none;\n}\n.oc-profile-dropdown .dropdown-toggle img {\n  width: 3.75rem;\n  border: 3px solid var(--oc-primary-color);\n}\n.oc-profile-dropdown .dropdown-menu {\n  border-radius: 0;\n  border-top-right-radius: 2.25rem;\n  padding-top: 0;\n  padding-bottom: 0.875rem;\n  overflow: hidden;\n  background-color: var(--oc-primary-bg);\n}\n.oc-profile-dropdown .dropdown-header {\n  font-family: \"DMSans-Bold\";\n  font-size: 1rem;\n  color: #fff;\n  background-color: var(--oc-primary-color);\n  margin-bottom: 0.625rem;\n}\n.oc-profile-dropdown .dropdown-item {\n  color: #fff;\n}\n.oc-profile-dropdown .dropdown-item.active {\n  font-family: \"DMSans-Bold\";\n  background-color: transparent;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
